<div class="h-100 d-flex justify-content-end align-items-center gap-30">
  <i class="cp icon-edit" tooltip="Edit supplier" (click)="onClick('editSupplier')"></i>
  <i class="cp far fa-trash-alt" tooltip="Delete supplier" (click)="onClick('deleteSupplier')"></i>
</div>
